import React, { Component } from 'react'
import { findDOMNode } from 'react-dom'

export default class Select extends Component {
  constructor (...props) {
    super(...props)
    this.state = {
      isFocused: false
    }
  }
  componentDidMount () {
    window.addEventListener('click', this._onWindowClick)
  }
  componentWillUnmount () {
    window.removeEventListener('click', this._onWindowClick)
  }
  _onWindowClick = (event) => {
    const dropdownElement = findDOMNode(this)
    if (event.target !== dropdownElement && !dropdownElement.contains(event.target) && this.state.isFocused) {
      this.setState({ isFocused: false })
    }
  }
  openMenu = (e) => {
    e.preventDefault()
    if (!this.state.isFocused) {
      this.setState({ isFocused: true })
    }
  }
  handleChange = (newValue) => {
    this.props.onChange(newValue)
    this.setState({ isFocused: false })
  }
  render () {
    let { value, onChange, placeholder, label, clearable } = this.props
    let options = this.props.options.slice(0)
    placeholder = placeholder || 'Select an option'

    if (clearable === undefined) {
      clearable = false
    }

    if (clearable || value === null || value === undefined) {
      options.unshift({ label: placeholder, value: '' })
      value = value || ''
    }

    let selectedOptionLabel = (options.find(o => o.value === value) || {}).label

    return (
      <div className={`typeahead-dropdown-container ${this.state.isFocused ? 'focus' : ''}`}>
        {label
          ? <label className='ncss-label pr3-sm'>{label}</label>
          : null
        }

        <div className='u-sm-b u-md-h'>
          <select value={value}
            onChange={(e) => onChange(e.target.value)}>
            {options.map(v => <option key={v.value} value={v.value}>{v.label}</option>)}
          </select>
        </div>

        <div className='typeahead-input z2 u-sm-h u-md-b'>
          <div className='ncss-flyout-btn bg-white u-full-width'
            onClick={this.openMenu}>
            {selectedOptionLabel}
          </div>
          <div className='typeahead-options ncss-flyout-options'>
            {options.map(o => <span className={`ncss-option pt1-sm pr5-sm pb1-sm pl5-sm ${o.value === value ? 'active' : ''}`}
              onClick={() => this.handleChange(o.value)}
              key={o.value}>
              {o.label}
            </span>)}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/src/components/ncss/Select.js